import { invalidateEventPageCache } from "@sajilni/cache";
import { getLanguages } from "../language";

/**
 * Bust all Redis event-page cache keys for an event (every locale + slug variant).
 * Best-effort: swallows Redis / language lookup failures.
 */
export async function invalidateEventPageCacheForEvent(
  eventId: string,
  slug?: string | null,
  previousSlug?: string | null
): Promise<void> {
  try {
    const languages = await getLanguages();
    await invalidateEventPageCache({
      eventId,
      slug,
      previousSlug,
      localeCodes: languages.map((language) => language.code),
    });
  } catch (error) {
    console.warn("[cache] event-page invalidation failed (non-blocking)", error);
  }
}
